import {
  FreeWithPuzzlePro,
  HStack,
  PaidByPuzzle,
  PaidByPuzzlePro,
  Skeleton,
  Text,
  VStack,
} from 'ui_2';
import { useFeeQuery } from '@puzzlehq/frontend-utils';

type Props = {
  onGetProClicked?: () => void;
  programId?: string;
  functionId?: string;
  coverageOverride?: {
    covered: boolean;
    coverageType: 'pro' | 'all' | 'none';
  };
};

export const FeeView = ({
  onGetProClicked,
  programId,
  functionId,
  coverageOverride,
}: Props) => {
  const feeQuery = useFeeQuery({
    programId,
    functionId,
  });

  const coverageType =
    coverageOverride?.coverageType ?? feeQuery.data?.feeCoverageType;
  const fee = feeQuery.data?.fee?.fee.total;
  const covered = coverageOverride?.covered ?? feeQuery.data?.covered;

  return (
    <HStack className='min-h-[44px] w-full items-baseline'>
      <Text font='regular-sm'>Fee</Text>
      <HStack className='flex-grow' />
      <VStack className='justify-end'>
        {(() => {
          if (coverageType === 'all') {
            return <PaidByPuzzle />;
          } else if (fee === undefined) {
            return <Skeleton className='h-4 w-12' />;
          } else {
            return (
              <VStack className='text-right'>
                <Text
                  className={`${
                    coverageType === 'pro' && covered ? 'line-through' : ''
                  }`}
                  font='regular-sm'
                >
                  {fee} ALEO
                </Text>
                {coverageType === 'pro' && covered && <PaidByPuzzlePro />}
                {coverageType === 'pro' && !covered && (
                  <FreeWithPuzzlePro onGetProClicked={onGetProClicked} />
                )}
              </VStack>
            );
          }
        })()}
      </VStack>
    </HStack>
  );
};
